import { render } from "./bookReadingClub.vue?vue&type=template&id=62502cfc"
import script from "./bookReadingClub.vue?vue&type=script&lang=js"
export * from "./bookReadingClub.vue?vue&type=script&lang=js"

import "./bookReadingClub.vue?vue&type=style&index=0&id=62502cfc&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__